function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_41547_42192)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.3655 4.58213C20.0796 3.5152 18.9829 2.88203 17.916 3.16792L2.46115 7.30902C1.39422 7.59491 0.761051 8.69158 1.04693 9.75851L1.56457 11.6904C3.16497 11.2615 4.80998 12.2113 5.23881 13.8117C5.66763 15.4121 4.71789 17.0571 3.11749 17.4859L3.63513 19.4178C3.92101 20.4847 5.01768 21.1179 6.08462 20.832L21.5394 16.6909C22.6064 16.405 23.2395 15.3083 22.9536 14.2414L22.436 12.3095C20.8356 12.7384 19.1906 11.7886 18.7618 10.1882C18.3329 8.58782 19.2827 6.94281 20.8831 6.51398L20.3655 4.58213Z",
  fill: "#4E8DD7",
  stroke: "#4E8DD7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.80859 7.94678L8.58505 10.8446",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.62109 14.7083L10.3976 17.606",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_41547_42192"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgCouponIcon = function SvgCouponIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCouponIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coupon-icon.28d33c02.svg";
export { ForwardRef as ReactComponent };